import React from "react";
import { Box, CircularProgress, Pagination, Typography } from "@mui/material";
import FreightCard from "./FreightCard";
import {
  HUB_TABS,
  PAGE_SIZE,
  getHubTabMeta,
  getSummaryCountForTab,
} from "../carrierHub.mapper";

export default function FreightList({
  freights,
  page,
  totalCount,
  loading,
  error,
  selectedFreightId,
  acceptingFreightId,
  activeTab,
  summary,
  onTabChange,
  onSelectFreight,
  onAcceptFreight,
  onPageChange,
}) {
  const total = totalCount ?? 0;
  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
  const rangeStart = total === 0 ? 0 : (page - 1) * PAGE_SIZE + 1;
  const rangeEnd = Math.min(page * PAGE_SIZE, total);
  const showPagination = totalPages > 1;
  const tabMeta = getHubTabMeta(activeTab);

  return (
    <Box className="lances-list">
      <Box className="lances-tabs">
        {HUB_TABS.map((tab) => {
          const count = getSummaryCountForTab(summary, tab.key);
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              className={[
                "lances-tab",
                isActive ? "lances-tab--active" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => onTabChange?.(tab.key)}
              disabled={loading}
            >
              {tab.label} ({count})
            </button>
          );
        })}
      </Box>

      {loading && total === 0 && freights.length === 0 ? (
        <Box className="lances-list-empty">
          <CircularProgress size={32} sx={{ color: "#012443" }} />
          <Typography color="text.secondary" sx={{ mt: 2 }}>
            Carregando fretes...
          </Typography>
        </Box>
      ) : error ? (
        <Box className="lances-list-empty">
          <Typography color="error">{error}</Typography>
        </Box>
      ) : freights.length === 0 ? (
        <Box className="lances-list-empty">
          <Typography color="text.secondary">
            {tabMeta?.emptyText ||
              "Nenhum frete encontrado com os filtros aplicados."}
          </Typography>
        </Box>
      ) : (
        <>
          <Box className="lances-freight-cards">
            {freights.map((freight) => (
              <FreightCard
                key={freight.id}
                freight={freight}
                isSelected={selectedFreightId === freight.id}
                acceptingFreightId={acceptingFreightId}
                activeTab={activeTab}
                onSelect={onSelectFreight}
                onAcceptFreight={onAcceptFreight}
              />
            ))}
          </Box>

          {loading && (
            <Box className="lances-list-loading-overlay">
              <CircularProgress size={24} sx={{ color: "#012443" }} />
            </Box>
          )}
        </>
      )}

      {showPagination && (
        <Box className="lances-pagination">
          <Typography variant="body2" className="lances-pagination__info">
            Mostrando {rangeStart}–{rangeEnd} de {total}
          </Typography>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, value) => onPageChange(value)}
            color="primary"
            shape="rounded"
            disabled={loading}
            showFirstButton
            showLastButton
            siblingCount={1}
            boundaryCount={1}
            size="medium"
          />
        </Box>
      )}
    </Box>
  );
}
